import "venuescanner-scss/stylesheets/pages/homepage.scss";
import ScrollMagic from "scrollmagic";
import { pageLoaded, $ } from "venuescanner-js/tools/elemental";
import debounce from "lodash/debounce";

const mobileBreakpoint = 420;
const isMobile = window.innerWidth <= mobileBreakpoint ? "mobile" : "desktop";

const heroCarouselData = [
  {
    copy: "Brainstorms & burgers",
    image: {
      mobile:
        "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/teams/brainstorms_burgers_mobile.jpg",
      desktop:
        "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/teams/brainstorms_burgers.jpg",
    },
  },
  {
    copy: "Workshops & wine",
    image: {
      mobile:
        "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/teams/workshops_wine_mobile.jpg",
      desktop:
        "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/teams/workshops_wine.jpg",
    },
  },
  {
    copy: "Presentations & pizza",
    image: {
      mobile:
        "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/teams/presentations_pizza_mobile.jpg",
      desktop:
        "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/teams/presentations_pizza.jpg",
    },
  },
  {
    copy: "Conferences & cocktails",
    image: {
      mobile:
        "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/teams/conferences_cocktails_mobile.jpg",
      desktop:
        "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/teams/conferences_cocktails.jpg",
    },
  },
  {
    copy: "Meetings & margaritas",
    image: {
      mobile:
        "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/teams/meetings_margaritas_mobile.jpg",
      desktop:
        "https://s3.eu-west-2.amazonaws.com/venue.scanner/img/teams/meetings_margaritas.jpg",
    },
  },
];

// set first image depending on screen size less than 420px then show image
$(".homepage__hero-new__image__item").attr(
  "src",
  heroCarouselData[0].image[isMobile]
);
$(".homepage__hero-new__image").css({ opacity: "1" });

pageLoaded(() => {
  function handleResize() {
    const imageSize =
      window.innerWidth <= mobileBreakpoint ? "mobile" : "desktop";
    heroCarouselData.forEach((item, index) => {
      $($(".homepage__hero-new__image__item").get(index)).attr(
        "src",
        item.image[imageSize]
      );
    });
  }
  window.addEventListener(
    "resize",
    debounce(handleResize, 500, { leading: true, trailing: true })
  );

  //* **** hero image carousel
  let prevCarouselCounter = 0;
  let carouselCounter = 1;

  // wait until page load then load additional images
  heroCarouselData.forEach((item, index) => {
    if (index !== 0) {
      setTimeout(() => {
        $(".homepage__hero-new__image").append(
          `<img class="homepage__hero-new__image__item" src=${item.image[isMobile]} />`
        );
      }, index * 1000);
    }
  });

  // $('.venuescanner-logo-outline').addClass('animateIn')
  // setTimeout(() => {
  //   $('.venuescanner-logo-outline').removeClass('animateIn')
  //   $('.venuescanner-logo-outline').addClass('animateOut')
  // }, 2500 )

  // move isActive class through carouselImages on a loop
  setInterval(function () {
    // change and animate text
    $(".homepage__hero-new__copy__tagline").css({
      transform: "translate3d(0, 15px, 0)",
      opacity: "0",
      transition: "transform 0.15s ease, opacity 0.1s ease",
    });

    setTimeout(function () {
      $(".homepage__hero-new__copy__tagline").css({
        transform: "translate3d(0, 0, 0)",
        opacity: "1",
        transition: "transform 0.3s ease, opacity 0.2s ease",
      });
      $(".homepage__hero-new__copy__tagline").text(
        heroCarouselData[carouselCounter].copy
      );
      carouselCounter === heroCarouselData.length - 1
        ? (carouselCounter = 0)
        : carouselCounter++;
      prevCarouselCounter === heroCarouselData.length - 1
        ? (prevCarouselCounter = 0)
        : prevCarouselCounter++;
    }, 250);

    // change and animate images
    $($(".homepage__hero-new__image__item").get(carouselCounter)).addClass(
      "isActive"
    );
    $(
      $(".homepage__hero-new__image__item").get(prevCarouselCounter)
    ).removeClass("isActive");
  }, 4500);
});
